export default __webpack_public_path__ + "static/media/instruction.3632d118.pdf";